import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { withPrefix } from "@/utils/redirect";
export default /*#__PURE__*/ _defineComponent({
    __name: 'VisualizationFrame',
    props: {
        datasetId: null,
        visualization: null,
        visualizationId: null
    },
    setup(__props) {
        const props = __props;
        const srcWithRoot = computed(() => {
            let url = "";
            if (props.visualization === "trackster") {
                if (props.datasetId) {
                    url = `/visualization/trackster?dataset_id=${props.datasetId}`;
                }
                else {
                    url = `/visualization/trackster?id=${props.visualizationId}`;
                }
            }
            else {
                if (props.datasetId) {
                    url = `/plugins/visualizations/${props.visualization}/show?dataset_id=${props.datasetId}`;
                }
                else {
                    url = `/plugins/visualizations/${props.visualization}/saved?id=${props.visualizationId}`;
                }
            }
            return withPrefix(url);
        });
        return { __sfc: true, props, srcWithRoot };
    }
});
